<template>
    <span>
        {{serverName}}
    </span>
</template>

<script>
    let elvenStats = require('../lib/elven-stats');
    export default {
        name: "es-server-name",
        props: {
            server: {required: true}
        },
        computed: {
            serverName: {
                get: function() {
                    return elvenStats.mapDomainAndServerName( this.server );
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ElvServerName.vue